export default __webpack_public_path__ + "static/media/dolce.6aff59a3.jpg";